import { modalBibliographySearchResultStore } from '@/store'
import { ModalBibliographySearchResultInterface } from '@/store/ModalBibliographySearchResultStore'

export class ModalBibliographySearchResultService {
  public open(params?: ModalBibliographySearchResultInterface) {
    modalBibliographySearchResultStore.open(params)
  }

  public close() {
    modalBibliographySearchResultStore.close()
  }
}
